module.exports = __webpack_public_path__ + "img/lighthouse.6f169d89.png";